const WALLET_SESSION_KEY = "wallet_connected_at";
const WALLET_SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export const setWalletSession = () => {
  localStorage.setItem(WALLET_SESSION_KEY, Date.now().toString());
};

export const clearWalletSession = () => {
  localStorage.removeItem(WALLET_SESSION_KEY);
  localStorage.removeItem("walletEvent");
};

export const isWalletSessionExpired = () => {
  const connectedAt = localStorage.getItem(WALLET_SESSION_KEY);

  if (!connectedAt) return true;

  return Date.now() - Number(connectedAt) > WALLET_SESSION_DURATION;
};
